export const API_URL = "https://forkify-api.jonas.io/api/v2/recipes"; 
export const TIMEOUT_SECONDS = 100; 
export const RES_PER_PAGE = 10;
export const KEY = "961799bd-4b9a-4cab-95f4-f7b48ea15fee"; 
export const MODAL_CLOSE_SEC = 2.5;